var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export var maskSMS = function (sms) {
    return "(XXX) XXX-".concat(sms.slice(sms.length - 4));
};
/**
 * Emails returned from the backend have two pre-masked formats as
 * of 7/25/22 they are:
 *
 *   1. jef******@ally.com
 *   2. je......n@ally.com
 *
 * #2 is modified below to the expected format, but #1 is displayed
 * as returned from the server.
 */
export var maskEmail = function (email) {
    // if masked on the server, return as is
    if (email.includes('***')) {
        return email;
    }
    var _a = __read(email.split('@'), 2), username = _a[0], domain = _a[1];
    if (username && domain) {
        // If the email is a@ally.com we don't want to mask it
        if (username.length === 1) {
            return email;
        }
        var firstChar = username.charAt(0);
        var lastChar = username.charAt(username.length - 1);
        return "".concat(firstChar, "...").concat(lastChar, "@").concat(domain);
    }
    return email;
};
/**
 * this accommodates two types:
 * DeliveryType (SMS | EMAIL | '') and
 * ReadableDeliveryMethod (text message | email | unknown)
 *
 * if we get unknown or empty string, simply return the raw Transmit value
 */
export var maskBy = {
    'text message': maskSMS,
    sms: maskSMS,
    SMS: maskSMS,
    voice: maskSMS,
    VOICE: maskSMS,
    email: maskEmail,
    EMAIL: maskEmail,
    unknown: function (value) { return value; },
    '': function (value) { return value; },
};
//# sourceMappingURL=maskOTP.js.map